<template>
  <GeneralForm :jenisJurnal="5" :title="title" :routeBack="routeBack" :jurnalUrl="url" />
</template>

<script>
import GeneralForm from '@/views/jurnal/GeneralForm.vue';

export default {
    components: {
        GeneralForm
    },
    data:() => ({
       title : 'Jurnal Pemakaian Persediaan (JPBIK)',
       url : '/api/ju',
       routeBack : 'jpbiklist',
    }),
    methods: {
       
    }
}
</script>


<style>

</style>